import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom'; // Import Routes and Route
import ActivateNews from './ActivateNews';
import MatchupsPage from './Matchups';
import { Header, Footer, QBxHeader, QBxFooter, B10Footer, B10Header, CFPFooter, CFPHeader } from './Global';
import { Leaders, Weekly } from './Leaders';
import { Groups, News, NewsForm } from './OtherPages';
import Profile from './Profile';
import Group from './Group';
import { SimplePage, BigTenRules, QBxRules } from './help';
import ProcessLeaderboard from './ProcessLeaderboard';
import Home from './Home';
import { googleLogout, useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { fetchUserProfile } from './services/api';
import AddToHomeScreenButton from './HomeScreen';
import NewGame from './NewGame';
import { Auction, QBxLeaders } from './Auction';
import B10Leaders from './B10Leaders';
import { More, PlayoffProjection } from './More';
import Wrapped from './Wrapped';

//Projectors
import {Projector} from './cfbp/projectors/projector';
import {Projector2} from './cfbp/projectors/projector2';
import {Projector2023} from './cfbp/projectors/projector2023';
import {Projector2022} from './cfbp/projectors/projector2022';
import { Projector2021 } from './cfbp/projectors/projector2021';
import { Projector2020 } from './cfbp/projectors/projector2020';

import ProjectorYear from './cfbp/projectorYear';

//Ratings
import { ratings2 } from './cfbp/ratings/ratings2';
import { ratings } from './cfbp/ratings/ratings';
import { ratings26 } from './cfbp/ratings/ratings26';
import { ratings2023 } from './cfbp/ratings/ratings2023';
import { ratings2022 } from './cfbp/ratings/ratings2022';
import { ratings2021 } from './cfbp/ratings/ratings2021';
import { ratings2020 } from './cfbp/ratings/ratings2020';

//Teams
import { espnteams26 } from './cfbp/teams/espnteams26';
import { espnteams } from './cfbp/teams/espnteams';
import { espnteams2023 } from './cfbp/teams/espnteams2023';
import { espnteams2022 } from './cfbp/teams/espnteams2022';
import { espnteams2 } from './cfbp/teams/espnteams2';
import { espnteams2021 } from './cfbp/teams/espnteams2021';
import { espnteams2020 } from './cfbp/teams/espnteams2020';

//Games
import { espngames26 } from './cfbp/games/espngames26';
import { espngames2 } from './cfbp/games/espngames2';
import { espngames } from './cfbp/games/espngames';
import { espngames2023 } from './cfbp/games/espngames2023';
import { espngames2022 } from './cfbp/games/espngames2022';
import { espngames2021 } from './cfbp/games/espngames2021';
import { espngames2020 } from './cfbp/games/espngames2020';



import Players from './Players';
import WeeklyMatchup from './WeeklyMatchup';
import CompareWeek from './CompareWeek';
import WeeklyMatchupList from './WeeklyMatchupList';
import NotificationGenerator from './NotificationGenerator';
import { subscribeToPushNotifications } from './functions/index';
import { sendNotification } from './functions/sendNotification';

import Picks from './Picks';



import TeamRankings from './TeamRankings';
import 'firebase/storage';


// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBEIWLJMhCbfeAImiAzhnNxqioaaHNiKDw",
    authDomain: "our-cursor-419515.firebaseapp.com",
    projectId: "our-cursor-419515",
    storageBucket: "our-cursor-419515.appspot.com",
    messagingSenderId: "862090443322",
    appId: "1:862090443322:web:d9cfd958b990f8d5055303",
    measurementId: "G-WVK25PX7W2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

const App = () => {
    const [currentPage, setCurrentPage] = useState('games');
    const [group, setGroup] = useState(null);
    const [week, setWeek] = useState(null);
    const [opponent, setOpponent] = useState(null);
    const [matchup, setMatchup] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [user, setUser] = useState(null);
    const [profile, setProfile] = useState(null);

    const navigate = useNavigate();

    const [notificationsStatus, setNotificationsStatus] = useState(null);

    useEffect(() => {
        const checkNotificationStatus = async () => {
            if (Notification.permission === 'granted') {
                setNotificationsStatus("granted");
                return;
            }

            if (Notification.permission === 'denied') {
                setNotificationsStatus("denied");
                return;
            }

            const registration = await navigator.serviceWorker.getRegistration();
            if (registration) {
                const pushSubscription = await registration.pushManager.getSubscription();
                if (pushSubscription) {
                    setNotificationsStatus("granted");
                }
            }
        };

        checkNotificationStatus();
    }, []);

    const enableNotifications = async () => {
        const result = await subscribeToPushNotifications(JSON.parse(localStorage.getItem('profile')));
        setNotificationsStatus(result);
    }

    // Function to refresh access token
    const refreshAccessToken = async () => {
        // Your token refreshing logic here
    };

    useEffect(() => {
        const loggedIn = localStorage.getItem('login') === '1';
        setIsLoggedIn(loggedIn);
        if (loggedIn) {
            const storedUser = JSON.parse(localStorage.getItem('user'));
            setUser(storedUser);
        }
    }, []);

    const login = useGoogleLogin({
        onSuccess: (codeResponse) => {
            setUser(codeResponse);
            setIsLoggedIn(true);
            localStorage.setItem('currentPage', 'games');
            localStorage.setItem('login', '1');
            localStorage.setItem('user', JSON.stringify(codeResponse));
            setCurrentPage('games');
        },
        onError: (error) => console.log('Login Failed:', error)
    });

    useEffect(() => {
        const storedPage = localStorage.getItem('currentPage');
        if (storedPage) {
            setCurrentPage(storedPage);
        }
    }, []);

    useEffect(() => {
        if (user && (!localStorage.getItem('profile'))) {

            axios.get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
                headers: {
                    Authorization: `Bearer ${user.access_token}`,
                    Accept: 'application/json'
                }
            })
            .then((res) => {
                const fetchData = async () => {
                    try {
                        const userProfile = await fetchUserProfile(res, setProfile);
                        setProfile(userProfile);
                        localStorage.setItem('profile', JSON.stringify(userProfile));
                    }
                    catch {

                    }
                }

                fetchData();
            })
            .catch((err) => {
                if (err.response.status === 401) {
                    refreshAccessToken();
                }
            });
        }
    }, [user, profile]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        localStorage.setItem('currentPage', page);
    };

    const handleLogout = () => {
        googleLogout();
        setIsLoggedIn(false);
        setUser(null);
        setProfile(null);
        localStorage.removeItem('profile');
        localStorage.removeItem('login');
        localStorage.removeItem('user');
        localStorage.removeItem('currentPage');

        navigate('/');
    };

    const renderPage = () => {

        if ((isLoggedIn || localStorage.getItem('login'))) {
            switch (currentPage) {
                case 'games':
                    return (
                        <>
                        <Header onPageChange={handlePageChange} />
                            <MatchupsPage db={database} onPageChange={handlePageChange} enableNotifications={enableNotifications} notificationsStatus={notificationsStatus} />
                            <Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    );
                case 'picks':
                    return (
                        <>
                            <Header onPageChange={handlePageChange} />
                            <Picks />
                            <Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    );
                case 'groups':
                    return (
                        <>
                        <Header onPageChange={handlePageChange} />
                            <Groups setGroup={setGroup} onPageChange={handlePageChange} />
                            <Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    );
                    case 'group':
                    return (
                        <>
                        <Header onPageChange={handlePageChange} />
                            <Group setGroup={setGroup} group={group} onPageChange={handlePageChange} setMatchup={setMatchup} />
                            <Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    );
                case 'help':
                    return (
                        <>
                        <Header onPageChange={handlePageChange} />
                            <SimplePage />
                            <Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    );
                case 'helpb10':
                    return (
                        <>
                            <B10Header onPageChange={handlePageChange} />
                            <BigTenRules />
                            <B10Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    );
                case 'helpQBX':
                    return (
                        <>
                            <QBxHeader onPageChange={handlePageChange} />
                            <QBxRules />
                            <QBxFooter currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    );
                case 'leaderboard':
                    return (
                        <>
                        <Header onPageChange={handlePageChange} />
                            <Leaders onPageChange={handlePageChange} setWeek={setWeek} setOpponent={setOpponent} />
                            <Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    );
                 case 'b10leaders':
                    return (
                        <>
                            <B10Header />
                            <B10Leaders onPageChange={handlePageChange} />
                            <B10Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    );
                case 'weekly':
                    return (
                        <>
                        <Header onPageChange={handlePageChange} />
                            <Weekly onPageChange={handlePageChange} setCompareWeek={setWeek} setOpponent={setOpponent} />
                            <Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    );
                case 'profile':
                    return (
                        <>
                            <Header onPageChange={handlePageChange} />
                            <Profile onPageChange={handlePageChange} db={database} user={user} profile={profile} onLogout={handleLogout} enableNotifications={enableNotifications} />
                            <Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    );
                    case 'notification':
                    return (
                        <>
                            <Header onPageChange={handlePageChange} />
                            <NotificationGenerator db={database} user={user} profile={profile} />
                            <Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    );
                 case 'news':
                    return (
                        <>
                        <Header onPageChange={handlePageChange} />
                            <News onPageChange={handlePageChange} />
                            <Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    );
                    case 'newsForm':
                    return (
                        <>
                        <Header onPageChange={handlePageChange} />
                            <NewsForm onPageChange={handlePageChange} />
                            <Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    );
                case 'nfl-teams':
                    return (
                        <>
                            <Header onPageChange={handlePageChange} />
                            <TeamRankings type="nfl" />
                            <Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    );
                    case 'ncaa-teams':
                    return (
                        <>
                            <B10Header />
                            <TeamRankings type="ncaa" />
                            <B10Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    );
                    case 'newGame':
                        return (
                            <>
                                <B10Header />
                            <NewGame  db={database} onPageChange={handlePageChange} type="ncaa" />
                            <B10Footer currentPage={currentPage} onPageChange={handlePageChange} />
                            </>
                        );
                        case 'auctionGame':
                        return (
                            <>
                            <QBxHeader onPageChange={handlePageChange} league="auction" />
                            <Auction />
                            <QBxFooter currentPage={currentPage} onPageChange={handlePageChange} />
                            </>
                    )
                case 'qbxLeaders':
                    return (
                        <>
                            <QBxHeader onPageChange={handlePageChange} league="auction" />
                            <QBxLeaders />
                            <QBxFooter currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    )
                case 'more':
                    return (
                        <>
                            <Header onPageChange={handlePageChange} />
                            <More onPageChange={handlePageChange} />
                            <Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    )
                case 'wrapped':
                    return (
                        <>
                            <Wrapped />
                            <Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    )
                    case 'cfp':
                    return (
                        <>
                            <CFPHeader />
                            <PlayoffProjection />
                            <CFPFooter currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    )
                case 'players':
                    return (
                        <>
                            <Players />
                            <Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    )
                case 'matchup':
                    return (
                        <><Header onPageChange={handlePageChange} />
                            <WeeklyMatchup group={group}  matchup={matchup} onPageChange={handlePageChange} />
                            <Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    )
                    case 'compare':
                    return (
                        <><Header onPageChange={handlePageChange} />
                            <CompareWeek opponent={opponent} setOpponent={setOpponent}  week={week} onPageChange={handlePageChange} />
                            <Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    )
                case 'matchupList':
                    return (
                        <><Header onPageChange={handlePageChange} />
                            <WeeklyMatchupList setGroup={setGroup} onPageChange={handlePageChange} />
                            <Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    )
                default:
                    return (
                        <>
                        <Header onPageChange={handlePageChange} />
                            <Leaders onPageChange={handlePageChange} />
                            <Footer currentPage={currentPage} onPageChange={handlePageChange} />
                        </>
                    );
            }
        } else {
            return (
                <AddToHomeScreenButton isLoggedIn={isLoggedIn} login={login} />
            )
        }
    };



   const location = useLocation();

// Normalize pathname (remove trailing slash)
const path = location.pathname.replace(/\/$/, "");

// Extract year from URL
let year = null;

if (path === "/projection") {
  year = 2026; // default
} else if (path.startsWith("/projection/")) {
  const parsed = Number(path.split("/")[2]);
  if (!Number.isNaN(parsed)) year = parsed;
}

// Data map
const projectionConfig = {
  2026: { teams: espnteams26, games: espngames26, ratings: ratings26, initialWeek: 14 },
  2025: { teams: espnteams, games: espngames, ratings },
  2024: { teams: espnteams2, games: espngames2, ratings: ratings2 },
  //2023: { teams: espnteams2023, games: espngames2023, ratings: ratings2023, initialWeek: 14 },
  //2022: { teams: espnteams2022, games: espngames2022, ratings: ratings2022, initialWeek: 14 },
  //2021: { teams: espnteams2021, games: espngames2021, ratings: ratings2021, initialWeek: 14 },
  //2020: { teams: espnteams2020, games: espngames2020, ratings: ratings2020 },
};

var projection = year ? projectionConfig[year] : null;

if(projection == null){
    projection = projectionConfig[2026];
    year = 2026;
}

return (
  <div>
        {(path === "/projection" || path.startsWith("/projection")) && projection ? (
      <ProjectorYear
        year={year}
        initialWeek={projection.initialWeek || 15}
        teamRatings={projection.teams}
        gamesData={projection.games}
        ratingModel={projection.ratings}
      />
    ) : (
      <>
        <Routes>
          <Route path="/trigger-script" element={<ProcessLeaderboard />} />
          <Route path="/" element={<Home />} />
        </Routes>

        {renderPage()}
      </>
    )}
  </div>
);

};

export default App;
